module.exports = __webpack_public_path__ + "static/Adventure Book-ffbac1319e46f68e808e83fbb2ec02d9.mp4";